import React, { useEffect, useState } from 'react';
import { Icon } from 'react-icons-kit'
import { ic_chevron_right } from 'react-icons-kit/md/ic_chevron_right'
import { ic_chevron_left } from 'react-icons-kit/md/ic_chevron_left'
import { ic_directions_walk } from 'react-icons-kit/md/ic_directions_walk'
import { ic_work } from 'react-icons-kit/md/ic_work'
import { wrench } from 'react-icons-kit/ionicons/wrench'
import { ic_person } from 'react-icons-kit/md/ic_person'
import { ic_group } from 'react-icons-kit/md/ic_group'
import { ic_file_present } from 'react-icons-kit/md/ic_file_present'
import { ic_file_copy_outline } from 'react-icons-kit/md/ic_file_copy_outline'
import { handshakeO } from 'react-icons-kit/fa/handshakeO'
import { coinDollar } from 'react-icons-kit/icomoon/coinDollar'
import { umbrella } from 'react-icons-kit/fa/umbrella'
import Nav from 'react-bootstrap/Nav'
import Collapse from 'react-bootstrap/Collapse'
import Tooltip from '@material-ui/core/Tooltip';
import { ic_person_pin_outline } from 'react-icons-kit/md/ic_person_pin_outline'
import api from '../../services/api'
import icon from '../../imgs/icon2.png';
import './index.css';
import { fileText } from 'react-icons-kit/icomoon/fileText'

function NavBar(props) {
    const [hide, setHide] = useState(true);
    const [openCadastros, setOpenCadastros] = useState(false)
    const [openEstoque, setOpenEstoque] = useState(false)
    const [openOfertas, setOpenOfertas] = useState(false)
    const [openAcompanhamento, setOpenAcompanhamento] = useState(false)
    const [openFerramentas, setOpenFerramentas] = useState(false)
    // const selected = props.selected;
    const [tipoGrupo, setTipoGrupo] = useState('')
    const [auth, setAuth] = useState(JSON.parse(localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })));

    useEffect(() => {
        const fetchData = async () => {

            setTipoGrupo(await api.getTipoGrupo(auth.user))
            console.log(tipoGrupo)

        }

        fetchData()
    }, [])


    function toggleNavBarHide(e, item) {
        e.preventDefault();
        setHide(!hide)
    }

    function openWindow() {
        let url = api.backendUrl + '/static/' + 'CondGerais.pdf'
        window.open(url)
    }

    return (
        <div className={"Navbar" + (hide ? '-hide' : '')}>
            <button onClick={toggleNavBarHide} className="toggle_navbar">
                {hide ? <Icon icon={ic_chevron_right} size={40} /> : <Icon icon={ic_chevron_left} size={40} />}
            </button>
            <Nav justify defaultActiveKey="/sistema/home" className="flex-column" style={{ width: '100%' }}>
                <Tooltip title="Segure Ctrl para abrir em nova aba" style={{ alignSelf: 'center', alignItems: 'center', justifyContent: 'center' }}>
                    <Nav.Link href="/sistema/home">
                        {hide ? <img alt='Expandir' src={icon} className="fr_icon_navbar" /> : <img alt='Encolher' src={icon} className="fr_logo_navbar" />}
                    </Nav.Link>
                </Tooltip>

                <Tooltip title="Segure Ctrl para abrir em nova aba" hidden={tipoGrupo === 'A'} >
                    <Nav.Link href="/sistema/propostas" style={{ padding: 0 }} hidden={tipoGrupo === 'A'}>
                        <div className={(hide ? 'hide-' : '') + "toggleMenuButton"} hidden={tipoGrupo === 'A'}>
                            <Icon icon={ic_work} size={22} />
                            {hide ? '' : <strong style={{ paddingLeft: '10px' }}>{'Propostas'}</strong>}
                        </div>
                    </Nav.Link>
                </Tooltip>

                <Tooltip title="Segure Ctrl para abrir em nova aba" hidden={tipoGrupo !== 'M'}>
                    <Nav.Link href="/sistema/usuarios" style={{ padding: 0 }} hidden={tipoGrupo !== 'M'} >
                        <div className={(hide ? 'hide-' : '') + "toggleMenuButton"} hidden={tipoGrupo !== 'M'}>
                            <Icon icon={ic_person} size={22} />
                            {hide ? '' : <strong style={{ paddingLeft: '10px' }}>{'Usuários'}</strong>}
                        </div>
                    </Nav.Link>
                </Tooltip>
                {console.log((tipoGrupo !== 'M') && (tipoGrupo !== 'A'))}
                <Tooltip title="Segure Ctrl para abrir em nova aba" hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'A')}>
                    <Nav.Link href="/sistema/propostaAssociado" style={{ padding: 0 }} hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'A')}>
                        <div className={(hide ? 'hide-' : '') + "toggleMenuButton"} hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'A')}>
                            <Icon icon={ic_file_copy_outline} size={22} />
                            {hide ? '' : <strong style={{ paddingLeft: '10px' }}>{'Proposta Associado'}</strong>}
                        </div>
                    </Nav.Link>
                </Tooltip>

                <Tooltip title="Segure Ctrl para abrir em nova aba">
                    <Nav.Link href="/sistema/financeiro" style={{ padding: 0 }}>
                        <div className={(hide ? 'hide-' : '') + "toggleMenuButton"}>
                            <Icon icon={coinDollar} size={22} />
                            {hide ? '' : <strong style={{ paddingLeft: '10px' }}>{'Financeiro'}</strong>}
                        </div>
                    </Nav.Link>
                </Tooltip>

                <Tooltip title="Segure Ctrl para abrir em nova aba" hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'A')}>
                    <Nav.Link href="/sistema/coberturas" style={{ padding: 0 }} hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'A')}>
                        <div className={(hide ? 'hide-' : '') + "toggleMenuButton"} hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'A')}>
                            <Icon icon={umbrella} size={22} />
                            {hide ? '' : <strong style={{ paddingLeft: '10px' }}>{'Coberturas'}</strong>}
                        </div>
                    </Nav.Link>
                </Tooltip>

                <Tooltip title="Segure Ctrl para abrir em nova aba" hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'A')}>
                    <Nav.Link href="/sistema/coberturas/cadastro" style={{ padding: 0 }} hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'A')}>
                        <div className={(hide ? 'hide-' : '') + "toggleMenuButton"} hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'A')}>
                            <Icon icon={ic_person_pin_outline} size={22} />
                            {hide ? '' : <strong style={{ paddingLeft: '10px' }}>{'Informações Cadastrais - Associado'}</strong>}
                        </div>
                    </Nav.Link>
                </Tooltip>

                <Tooltip title="Segure Ctrl para abrir em nova aba" hidden={tipoGrupo === 'A'}>
                    <Nav.Link href="/sistema/parceiro_venda" style={{ padding: 0 }} hidden={tipoGrupo === 'A'}>
                        <div className={(hide ? 'hide-' : '') + "toggleMenuButton"} hidden={tipoGrupo === 'A'}>
                            <Icon icon={handshakeO} size={22} />
                            {hide ? '' : <strong style={{ paddingLeft: '10px' }}>{'Informações Cadastrais - Parceiro'}</strong>}
                        </div>
                    </Nav.Link>
                </Tooltip>

                <Tooltip title="Segure Ctrl para abrir em nova aba" hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'A') && (tipoGrupo !== 'P')}>
                    <Nav.Link href="/sistema/home" style={{ padding: 0 }} onClick={openWindow} hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'A') && (tipoGrupo !== 'P')}>
                        <div className={(hide ? 'hide-' : '') + "toggleMenuButton"} hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'A') && (tipoGrupo !== 'P')}>
                            <Icon icon={ic_file_present} size={22} />
                            {hide ? '' : <strong style={{ paddingLeft: '10px' }}>{'Termo de Adesão'}</strong>}
                        </div>
                    </Nav.Link>
                </Tooltip>

                <Tooltip title="Segure Ctrl para abrir em nova aba" hidden={tipoGrupo !== 'M'} >
                    <Nav.Link href="/sistema/grupos-usuarios" style={{ padding: 0 }} hidden={tipoGrupo !== 'M'} >
                        <div className={(hide ? 'hide-' : '') + "toggleMenuButton"} hidden={tipoGrupo !== 'M'} >
                            <Icon icon={ic_group} size={22} />
                            {hide ? '' : <strong style={{ paddingLeft: '10px' }}>{'Grupos de Usuários'}</strong>}
                        </div>
                    </Nav.Link>
                </Tooltip>

                <Tooltip title="Segure Ctrl para abrir em nova aba" hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'P')}>
                    <Nav.Link href="/sistema/vendedores" style={{ padding: 0 }} hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'P')}>
                        <div className={(hide ? 'hide-' : '') + "toggleMenuButton"} hidden={(tipoGrupo !== 'M') && (tipoGrupo !== 'P')}>
                            <Icon icon={ic_directions_walk} size={22} />
                            {hide ? '' : <strong style={{ paddingLeft: '10px' }}>{'Vendedores'}</strong>}
                        </div>
                    </Nav.Link>
                </Tooltip>

                {/* <Tooltip title="Segure Ctrl para abrir em nova aba">
                    <Nav.Link href="/sistema/configuracoes" style={{ padding: 0 }}>
                        <div className={(hide ? 'hide-' : '') + "toggleMenuButton"}>
                            <Icon icon={wrench} size={22} />
                            {hide ? '' : <strong style={{ paddingLeft: '10px' }}>{'Configurações'}</strong>}
                        </div>
                    </Nav.Link>
                </Tooltip> */}


                <Tooltip title="Segure Ctrl para abrir em nova aba" hidden={tipoGrupo === 'A'}>
                    <Nav.Link href="/sistema/RelatorioComissoes" style={{ padding: 0 }} hidden={tipoGrupo === 'A'}>
                        <div className={(hide ? 'hide-' : '') + "toggleMenuButton"} hidden={tipoGrupo === 'A'}>
                            <Icon icon={fileText} size={22} />
                            {hide ? '' : <strong style={{ paddingLeft: '10px' }}>{'Relatório Comissionamento'}</strong>}
                        </div>
                    </Nav.Link>
                </Tooltip>



            </Nav>
        </div >
    );
}

export default NavBar;